<template>
  <sn-expansion-panels
    v-model="panel"
    expandable
    hide-shadow
    multiple
    style="width: 100%; height: auto"
  >
    <sn-expansion-panel
      v-for="(permissionGroup, groupIndex) in permissionGroups"
      :key="groupIndex + '-group'"
      :data-cy="groupDataCy(permissionGroup.name)"
      width="100%"
    >
      <template v-slot:header>
        <h4 class="toggle-header">
          {{ permissionGroup.name }}
        </h4>
      </template>
      <template v-slot:expansion>
        <div>
          <sr-permission-row
            v-for="(setting, rowIndex) in permissionGroup.settings"
            :key="groupIndex + '-' + rowIndex + '-row'"
            :data-cy="rowDataCy(setting.display_name)"
            :permission="setting"
            :view-only="viewOnly"
            class="permission-row item-border-bottom"
            @permissionChange="handleChange($event)"
          />
        </div>
      </template>
    </sn-expansion-panel>
  </sn-expansion-panels>
</template>

<script>

import srPermissionRow from './srPermissionRow'
import _ from 'lodash'

export default {
  name: 'SrPermissionGroups',
  components: {
    srPermissionRow
  },
  props: {
    permissionGroups: {
      type: Array,
      required: true
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      panel: undefined
    }
  },
  watch: {
    expanded (val) {
      this.expandAll(val)
    }
  },
  created () {
    this.expandAll(this.expanded)
  },
  methods: {
    expandAll (expanded) {
      const panel = []
      if (expanded) {
        this.permissionGroups.forEach((_group, index) => {
          panel.push(index)
        })
      }
      this.panel = panel
    },
    handleChange (changedPermissions) {
      this.$emit('permissionChange', changedPermissions)
    },
    groupDataCy (groupName) {
      return `permission-${_.kebabCase(groupName).toLowerCase()}`
    },
    rowDataCy (settingName) {
      return `permission-${_.kebabCase(settingName).toLowerCase()}`
    }
  }
}
</script>

<style lang="scss" scoped>

@import '~/assets/css/snui';

.toggle-header {
  font-size: 22px !important;
  line-height: 32px !important;
}

.permission-row {
  margin: 0;
}
::v-deep .v-expansion-panel-header {
  min-height: 56px !important;
}

</style>
